<div class="container">
  <div>
    <label for="file">Upload your file</label>
    <input type="file" class="file-input" (change)="uploadFile($event)" />
  </div>

  <img [src]="blobUrl" alt="Imagen" [hidden]="!blobUrl" />

  <hr />

  <div>
    <label for="file">Last File Uploaded</label>
    <div>{{ blobUrl || "None" }}</div>
    <button class="bg-primary-500 py-1 rounded-md" (click)="loadBlob()">
      Show on console
    </button>
  </div>
</div>
